import moment from 'moment';
import {useCallback, useContext} from 'react';

import {timeRangeWarningThresholds} from './constants';
import {TimeRangeLimitWarningContext} from './TimeRangeLimitWarningProvider';

import {DateRange, TimeScale} from '../../../../../../types';

export interface CheckTimeRangeParams extends Omit<DateRange, 'selectedDate'> {
    timeScale: TimeScale;
}
export interface CheckTimeRangeCallbacks {
    onConfirm?: () => void;
    onCancel?: () => void;
}
export type UseTimeRangeWarning = [
    (dateRange: CheckTimeRangeParams, callbacks: CheckTimeRangeCallbacks) => void
];

const doNothing = () => {};

const useTimeRangeWarning = (): UseTimeRangeWarning => {
    const {onOpen, doNotShowAgain} = useContext(TimeRangeLimitWarningContext);

    const checkTimeRange = useCallback(
        (
            {startDate, endDate, timeScale}: CheckTimeRangeParams,
            {onConfirm = doNothing, onCancel = doNothing}
        ) => {
            const threshold = timeRangeWarningThresholds[timeScale];

            if (!threshold || doNotShowAgain) {
                onConfirm();
                return;
            }

            const [input, diff] = threshold;
            const distance = moment(endDate)
                .endOf('day')
                .diff(startDate, diff, true);

            if (distance > input) {
                onOpen({
                    startDate,
                    endDate,
                    timeScale,
                    confirmCallback: onConfirm,
                    cancelCallback: onCancel
                });
                return;
            }
            onConfirm();
        },
        [onOpen, doNotShowAgain]
    );

    return [checkTimeRange];
};

export default useTimeRangeWarning;
